import { useEffect, useState } from 'react';
import { Eye, X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import BillPreviewModal from './GenerateBill';
import { HitApi } from '../../Api/ApiHit';
import { addBilling, addClientSurvey, searchSurvey, updateBilling, updateClient } from '../../constant/Constant';
import { getSelectedUnit } from '../../storage/Storage';
import { useNavigate, useParams } from 'react-router-dom';
import { allReduxClear, checkStaffData } from '../../utils/utils';
import toast from 'react-hot-toast';
import CustomModal from '../../components/CustomModal/CustumModal';
import AppButton from '../../components/AppButton/AppButton';
import { setDataAction } from '../../redux/Actions/SetDataAction';
import { SET_SURVEY_DATA } from '../../redux/ActionName/ActionName';

const BillSummary = () => {
    const [modal, setModal] = useState(false)
    const CreateSurvey = useSelector(state => state.CreateSurvey)
    const [showPreview, setShowPreview] = useState(false);
    const { id } = useParams();
    const BillingReducer = useSelector(state => state.BillingReducer);
    const bill = BillingReducer?.billSummary || {};
    const [BillingJson, setBillingJson] = useState(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()


    // useEffect(() => {
    //     if (CreateSurvey?.selectedSurvey === null)
    //         loadServeyForm()
    // }, [])

    // const loadServeyForm = () => {
    //     const json = {
    //         page: 1, limit: 10, search: {
    //             selected: true
    //         }
    //     }
    //     HitApi(json, searchSurvey).then((res) => {
    //         console.log("res--", res.data);
    //         if (res?.statusCode === 200) {
    //             dispatch(setDataAction(res?.data, SET_SURVEY_DATA))
    //         }
    //     })
    // }
    const handleGenerateBill = () => {
        let json = {
            billingStatus: true,
            serviceInfo: BillingReducer?.selectedServices,
            products: BillingReducer?.selectedProducts,
            memberShip: BillingReducer?.selectedMemberships,
            package: BillingReducer?.selectedPackages,
            billSummary: BillingReducer?.billSummary,
            paymentMethod: BillingReducer?.paymentMethod,
            clientInfo: BillingReducer?.clientInfo,
            noGst: BillingReducer?.noGst || false,
            unitIds: BillingReducer?.unitIds ? BillingReducer?.unitIds : getSelectedUnit()?._id
        };

        setBillingJson(json)
        if (BillingReducer.clientInfo === null) {
            toast.error("Select a client First")
        }
        else if (BillingReducer?.billSummary?.grandTotal === 0) {
            toast.error("Please add some service or products")
        }
        else if (!checkStaffData(BillingReducer)) {
            toast.error("Please select a Staff Member")
        }
        else if (BillingReducer?.billSummary?.payingNow === 0) {
            toast.error("Please select a Payment Method first")
        }
        else {
            console.log("json----", json);
            HitApi(json, id ? updateBilling : addBilling).then((res) => {
                console.log("res--for update billing", res);
                if (res?.statusCode === 201) {
                    if (bill?.duePayment !== 0 || BillingReducer?.clientInfo?.unpaidAmt !== 0) {
                        const json =
                        {
                            _id: BillingReducer.clientInfo._id,
                            unpaidAmt: bill.duePayment,
                            totalVisit: BillingReducer?.clientInfo?.totalVisit + 1
                        }
                        console.log("json due payemt", json);
                        HitApi(json, updateClient).then((res) => {
                            console.log("res--client uodate", res);
                        })
                    }
                    setShowPreview(true);
                }
                else {
                    toast.error("Something Went Wrong")
                }
            })
        }
    };
    const submitSurvey = () => {
        const json = {
            client_id: BillingReducer?.clientInfo?._id,
            questions: CreateSurvey?.selectedSurvey?.[0]?.questions,
            survey_id: CreateSurvey?.selectedSurvey[0]?._id,
        }
        HitApi(json, addClientSurvey).then((res) => {
            console.log("res---", res);
            if (res?.statusCode === 201) {
                surveyModalClose()
            }
            else {
                toast.error(res.message)
            }
        })
    }
    const surveyModalClose = () => {
        allReduxClear(dispatch);
        navigate("/")
        setModal(false)
    }



    const handelchange = (value, index) => {
        const oldSurvey = { ...CreateSurvey?.selectedSurvey?.[0] };

        const updatedQuestions = [...oldSurvey.questions];

        updatedQuestions[index] = { ...updatedQuestions[index], ans: value };

        const updatedSurvey = { ...oldSurvey, questions: updatedQuestions };
        console.log("updatedSurvey", updatedSurvey);
        console.log("CreateSurvey?.selectedSurvey?.[0]", CreateSurvey?.selectedSurvey);


        dispatch(setDataAction([updatedSurvey], SET_SURVEY_DATA));
    };

    return (
        <>
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-4 border border-gray-200 space-y-4">
                <h2 className="text-lg font-semibold text-gray-800 border-b pb-2 mb-2">Bill Summary</h2>

                <SummaryRow label="Subtotal (₹):" value={bill.subTotal} />

                {bill.extraCharges !== 0 && (
                    <SummaryRow label="Extra Charges (₹):" value={bill.extraCharges} />
                )}
                {bill.discount !== 0 && (
                    <SummaryRow
                        label={`Discount (${bill.discountValue}${bill.discountType === 'percentage' ? '%' : ''}):`}
                        value={`- ${bill.discount}`}
                        labelClass="text-red-600"
                        valueClass="text-red-600"
                    />
                )}
                <SummaryRow label="Taxable Amount (₹):" value={bill.taxableAmount} />
                <SummaryRow label={`GST ${bill.gstPercentage}%`} value={bill.GST?.toFixed(0)} />
                {BillingReducer?.clientInfo?.unpaidAmt ? <div className="border-t pt-3">
                    <SummaryRow
                        labelClass='text-red'
                        label="Balance Amount (₹):"
                        value={BillingReducer?.clientInfo?.unpaidAmt}
                        valueClass="font-bold text-red"
                    />
                </div> : ""}

                {bill?.duePayment ? <SummaryRow
                    labelClass="text-red"
                    label="Due Amount (₹):"
                    value={bill?.duePayment?.toFixed(0)}
                    valueClass="text-red font-medium"
                /> : ""}
                <div className="border-t pt-3">
                    <SummaryRow
                        label="Grand Total (₹):"
                        value={bill.grandTotal}
                        valueClass="font-bold text-green-700"
                    />
                </div>
                <SummaryRow
                    label="Paying Now (₹):"
                    value={bill.payingNow}
                    valueClass="text-blue-600 font-medium"
                />
                <button
                    onClick={handleGenerateBill}
                    className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                >
                    <Eye className="w-4 h-4" />
                    Generate Bill
                </button>
            </div>
            <BillPreviewModal
                reduxClear={true}
                isOpen={showPreview}
                onClose={() => setShowPreview(false)}
                billData={BillingJson}
                setModal={setModal}
                noModal={true}
            />
            {/* <CustomModal isOpen={modal} size="xl" onClose={() => setModal(false)}>
                <div className="p-10">
                   
                    <div className="flex justify-between items-center mb-10 border-b pb-5">
                        <h2 className="text-3xl font-bold text-gray-900">Submit Survey</h2>
                        <X
                            className="w-8 h-8 text-gray-500 hover:text-gray-700 cursor-pointer transition"
                            onClick={surveyModalClose}
                        />
                    </div>
                  
                    <div className="space-y-5">
                        {CreateSurvey?.selectedSurvey?.[0]?.questions?.map((q, index) => (
                            <div
                                key={index}
                                className="flex items-center justify-between px-6 py-5 bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200"
                            >
                                <span className="text-gray-800 text-lg font-medium">
                                    {q.question}
                                </span>
                                <input
                                    onChange={(e) => handelchange(e.target.checked, index)}
                                    type="checkbox"
                                    className="w-6 h-6 text-blue-600 accent-blue-600 rounded cursor-pointer focus:ring-2 focus:ring-blue-400"
                                />
                            </div>
                        ))}
                    </div>

                   
                    <div className="mt-10 flex justify-center">
                        <AppButton
                            onClick={submitSurvey}
                            buttontext="Submit"
                            className="px-10 py-4 text-lg rounded-2xl shadow-lg hover:shadow-xl transition"
                        />
                    </div>
                </div>
            </CustomModal> */}




        </>
    );
};

const SummaryRow = ({ label, value, labelClass = "", valueClass = "" }) => (
    <div className="flex justify-between text-sm">
        <p className={`text-gray-600 ${labelClass}`}>{label}</p>
        <p className={`text-gray-800 ${valueClass}`}>{value ?? 0}</p>
    </div>
);

export default BillSummary;